import { AnimateBox } from '../../components/animate-box'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'

const data1 = [
  {
    title: '北京理工大学',
    icon: `${STATIC_OBS_URL}/website/home/school/s1.png`
  },
  {
    title: '哈尔滨工业大学',
    icon: `${STATIC_OBS_URL}/website/home/school/s2.png`
  },
  {
    title: '武汉理工大学',
    icon: `${STATIC_OBS_URL}/website/home/school/s3.png`
  },
  {
    title: '北京交通大学',
    icon: `${STATIC_OBS_URL}/website/home/school/s4.png`
  },
  {
    title: '西北工业大学',
    icon: `${STATIC_OBS_URL}/website/home/school/s5.png`
  },
  {
    title: '同济大学',
    icon: `${STATIC_OBS_URL}/website/home/school/s6.png`
  }
]

const data2 = [
  // {
  //   title: '中国石油大学GCKontrol教学应用课程：油气储运仪表与过程控制',
  //   icon: `${STATIC_OBS_URL}/website/home/school/school-1.png`,
  //   url: 'https://www.bilibili.com/video/BV1r24y1C7Vy/?vd_source=6d378beef3fe2de6a546c574b1855252'
  // },
  {
    title: '2025世冠科技国产工业软件师资培训会暨协同育人项目分享会名师经验分享',
    icon: `https://static-download.globalcrown.com.cn/website/pictures/mtmoz8uq-a184703d09b343ee.png`,
    url: 'https://www.bilibili.com/video/BV1PEf4BwEVP/?spm_id_from=333.1387.homepage.video_card.click&vd_source=e12a82d31f8fa8b8b05e84a76e327ff6'
  },
  {
    title: '厦门大学教授详解GCKontrol工程仿真应用（Part 1）',
    icon: `https://static-download.globalcrown.com.cn/website/pictures/mtmoxu2n-9de069301c50449b.png`,
    url: 'https://www.bilibili.com/video/BV13MKJz3Eyx/?spm_id_from=333.1387.homepage.video_card.click&vd_source=e12a82d31f8fa8b8b05e84a76e327ff6'
  },
  {
    title: '厦门大学教授详解GCKontrol工程仿真应用（Part 2）',
    icon: `https://static-download.globalcrown.com.cn/website/pictures/mtmoxwcd-7b5f9c80123b48fe.png`,
    url: 'https://www.bilibili.com/video/BV1HH3xzWEHe/?spm_id_from=333.1387.homepage.video_card.click&vd_source=e12a82d31f8fa8b8b05e84a76e327ff6'
  },
  {
    title: '哈尔滨工程大学《计算思维》系列课程（一）：基于 PID 的汽车行驶速度控制原理 ',
    icon: `https://static-download.globalcrown.com.cn/website/pictures/mtmox5xx-5352267cfc574d55.png`,
    url: 'https://www.bilibili.com/video/BV1cD5LzvEtS/?spm_id_from=333.1387.homepage.video_card.click&vd_source=e12a82d31f8fa8b8b05e84a76e327ff6'
  },
  {
    title: '哈尔滨工程大学《计算思维》系列课程（二）：基于PID的汽车行驶速度控制建模实操过程',
    icon: `https://static-download.globalcrown.com.cn/website/pictures/mtmowc45-e65d77f7bbe04557.png`,
    url: 'https://www.bilibili.com/video/BV14pECzwExF/?spm_id_from=333.1387.homepage.video_card.click&vd_source=e12a82d31f8fa8b8b05e84a76e327ff6'
  },
  {
    title: '哈尔滨工程大学《计算思维》系列课程（三）：基于PID的汽车行驶速度控制模型仿真',
    icon: `https://static-download.globalcrown.com.cn/website/pictures/mtmoqzuj-e48013eee9294eed.png`,
    url: 'https://www.bilibili.com/video/BV1W8J7zsEWy/?spm_id_from=333.1387.homepage.video_card.click&vd_source=e12a82d31f8fa8b8b05e84a76e327ff6'
  }
]

const bannerUrl = `${STATIC_OBS_URL}/website/home/school/banner.png`

export const SchoolDetail = () => {
  return (
    <Wrap>
      <div className='school-detail'>
        <div className='banner-box' style={{ backgroundImage: `url(${bannerUrl})` }}>
          <div className='wrap'>
            <AnimateBox tagName='h1'>GCKontrol和GCAir助力高校教学科研</AnimateBox>
            <AnimateBox animateDelay={0.5} tagName='p'>
              加强系统设计与仿真的关键技术攻关和人才培养
            </AnimateBox>
          </div>
        </div>

        <div className='section-a'>
          <div className='wrap'>
            <AnimateBox tagName='h2'>GCKontrol & GCAir联合实验室</AnimateBox>
            <ul className='list'>
              <AnimateBox animateDelay={0.2} tagName='li'>
                教学和课程
              </AnimateBox>
              <AnimateBox animateDelay={0.4} tagName='li'>
                应用模型库开发
              </AnimateBox>
              <AnimateBox animateDelay={0.6} tagName='li'>
                科研项目
              </AnimateBox>
            </ul>
            <ul className='icons'>
              {data1.map((item, i) => {
                const { title, icon } = item
                return (
                  <AnimateBox animateDelay={0.6 + 0.2 * i} key={title} tagName='li'>
                    <img alt={title} src={icon} />
                    <p>{title}</p>
                  </AnimateBox>
                )
              })}
            </ul>
          </div>
        </div>

        <div className='section-b'>
          <AnimateBox tagName='h2'>教学应用</AnimateBox>
          <div className='wrap'>
            <ul className='list'>
              {data2.map((item, i) => {
                const { title, icon, url } = item
                return (
                  <AnimateBox animateDelay={0.2 * i} key={title} tagName='li'>
                    <div className='img'>
                      <div className='pic' style={{ backgroundImage: `url(${icon})` }} />
                    </div>
                    <div className='info'>
                      <h5>
                        <a href={url} rel='noreferrer' target='_blank'>
                          {title}
                        </a>
                      </h5>
                      <a className='look-more' href={url} rel='noreferrer' target='_blank'>
                        更多新闻
                      </a>
                    </div>
                  </AnimateBox>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </Wrap>
  )
}
